export default __webpack_public_path__ + "static/apercu-medium-b721ec05e899e63396ef57e8d7db3f11.ttf";